import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';

export interface ExportMenuItem {
  label: string;
  exportType: string;
}

interface Props {
  /** Legacy element-based anchor (still supported for backward compat) */
  anchorEl?: Element | null;
  /** Preferred: fixed coordinate anchor captured at click time */
  anchorPosition?: { top: number; left: number } | null;
  /** Called when menu closes. exportType is set when custom menuItems are used. */
  handleClose: (shouldExport: boolean, exportType?: string) => void;
  /** Optional custom menu items. When provided, these are shown instead of default "Export To CSV". */
  menuItems?: ExportMenuItem[];
}

export const ExportMenu = (props: Props) => {
  const { anchorEl, anchorPosition, handleClose, menuItems } = props;

  const usePositionMode = Boolean(anchorPosition);

  const items = menuItems && menuItems.length > 0
    ? menuItems
    : [{ label: 'Export To CSV', exportType: 'csv' }];

  return (
    <Popover
      id="export-menu"
      anchorReference={usePositionMode ? 'anchorPosition' : 'anchorEl'}
      anchorEl={usePositionMode ? undefined : (anchorEl || undefined)}
      anchorPosition={usePositionMode ? (anchorPosition || undefined) : undefined}
      open={usePositionMode ? Boolean(anchorPosition) : Boolean(anchorEl)}
      onClose={() => handleClose(false)}
      anchorOrigin={usePositionMode ? {
        vertical: 'top',
        horizontal: 'left',
      } : {
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Paper>
        <MenuList>
          {items.map((item) => (
            <MenuItem
              key={item.exportType}
              onClick={() => handleClose(true, item.exportType)}
            >
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
      </Paper>
    </Popover>);
};
